import { RootState } from 'store';

export const conversationsSelector = (state: RootState) => state.messages.conversations;
export const conversationsPendingSelector = (state: RootState) => state.messages.pending.conversations;
export const messageErrorsSelector = (state: RootState) => state.messages.errors.errors;

export const conversationSelector = (state: RootState) => state.messages.conversation;
export const conversationPendingSelector = (state: RootState) => state.messages.pending.conversation;

export const messagesSelector = (state: RootState) => state.messages.messages;
export const messagesPendingSelector = (state: RootState) => state.messages.pending.messages;
export const newMessagesCountSelector = (state: RootState) => state.messages.newMessagesCounter;

export const sentMessagePendingSelector = (state: RootState) => state.messages.pending.sentMessage;
export const messageAssetsSelector = (state: RootState) => state.messages.assets;
export const messageAssetsPendingSelector = (state: RootState) => state.messages.pending.assets;

export const rawMessagesSelector = (state: RootState) => state.messages.rawMessages;
export const lastMessagesSelector = (state: RootState) => state.messages.lastMessages;

export const isFirstMessagePendingSelector = (state: RootState) => state.messages.isFirstMessagePending;

export const creatorStatusesSelector = (state: RootState) => state.messages.creatorStatuses;
export const creatorsAvatarSelector = (state: RootState) => state.messages.creatorsAvatar;
export const messageCreatedAtSelector = (state: RootState) => state.messages.messageCreatedAt;
